var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.middlewareExecuted)?_c('v-app',[_c('v-main',[_c('v-container',{staticClass:"pa-0 pa-md-3 full-height align-start flex-column justify-center",attrs:{"fluid":"","fill-height":""}},[_c(_setup.RmpSpinnerLoader)],1)],1)],1):_c('router-view')
}
var staticRenderFns = []

export { render, staticRenderFns }